// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1AfE11EuQjub7m2A2-zWh4{overflow:hidden;border-radius:.7rem;height:.6rem}._1AfE11EuQjub7m2A2-zWh4._2KzyuQe-_P4atkaTVfLMoE{border-radius:.6rem;width:.6rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Wrapper": "_1AfE11EuQjub7m2A2-zWh4",
	"Vertical": "_2KzyuQe-_P4atkaTVfLMoE"
};
module.exports = ___CSS_LOADER_EXPORT___;
